module.exports = __webpack_public_path__ + "51af89db57811248f0d144176c020ec8.png";